import { Account, AccountType } from 'eve-account-client';

export function terminationBannerDisplay(account: Account): boolean {
  if (
    account.type === AccountType.EMPLOYER &&
    account.closedDate !== null &&
    account.closedDate !== undefined &&
    (account.closedReasonCode === 'ATMIS' || account.closedReason === 'ATMIS')
  ) {
    return true;
  }
  return false;
}

export default terminationBannerDisplay;
